export const stashListQueryKey = (stashId: string) => ["stash", stashId] as const;

export const stashDetailQueryKey = (
  stashId: string | undefined,
  collectionId: string | undefined,
  skipAuth: boolean,
) => ["stash", stashId, collectionId, skipAuth] as const;
